import { createFileRoute } from "@tanstack/react-router";
import { CATEGORY_PILLARS } from "@/data/category-pillars";
import { CategoryPillarPage, categoryPillarJsonLd } from "@/components/CategoryPillarPage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const pillar = CATEGORY_PILLARS["expat-vip"];

export const Route = createFileRoute("/expat-vip/")({
  head: () => {
    const url = `${SEO_SITE}/expat-vip`;
    return {
      meta: [
        { title: ctaTitle(pillar.metaTitle, "/expat-vip", "th")},
        { name: "description", content: ctaDesc(pillar.metaDesc, "/expat-vip", "th")},
        { property: "og:title", content: ctaTitle(pillar.metaTitle, "/expat-vip", "th")},
        { property: "og:description", content: ctaDesc(pillar.metaDesc, "/expat-vip", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/expat-vip")],
      scripts: categoryPillarJsonLd(pillar, url),
    };
  },
  component: () => <CategoryPillarPage pillar={pillar} />,
});
